import * as React from "react";

import {
  disableAudioModalMessage,
  setToggleAllAudios,
} from "../../../store/audio-slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

import ModalMessage from "../ModalMessage/ModalMessage";
import AudioPlayerBackground from "./AudioBackground/AudioPlayerBackground";
import AudioPlayerInteractiveEffect from "./AudioEffect/AudioPlayerInteractiveEffect";

const AudioPlayer: React.FC = () => {
  const {
    isBackgroundAudioEnabled,
    areAudioEffectsEnabled,
    audioModalMessageAlreadyShown,
  } = useAppSelector((state) => state.audio);
  const dispatch = useAppDispatch();

  return (
    <>
      {!audioModalMessageAlreadyShown ? (
        <ModalMessage
          message="message.audio.enableAudio"
          onApprove={() => {
            dispatch(disableAudioModalMessage(true));
            dispatch(setToggleAllAudios());
          }}
          onReject={() => {
            dispatch(disableAudioModalMessage(true));
          }}
        />
      ) : (
        <>
          {isBackgroundAudioEnabled && <AudioPlayerBackground />}

          {areAudioEffectsEnabled && <AudioPlayerInteractiveEffect />}
        </>
      )}
    </>
  );
};

export default AudioPlayer;
